module.exports = "/static/assets/21988681fa28c8ce37982ca26463a6f5.svg";